import axios from 'axios';

export function sendIPTrackingData(input){
    return axios({
       method: 'post',
       url: 'https://stageiptracking.xbees.in/api/UserTracker',
       data: input,
       headers: {
         'Content-Type': 'application/json'
       }
     });
}


// WEBPACK FOOTER //
// ./src/services/userIPTrack.js